import { SkullItem } from './SkullItem';
import { applyTranslationOrRotation } from "../../../../Domain/Scene/Manager/ToothTransformManager";

export const MovementControl = ({
    movement,
    isStepEditMode,
    stepValues,
    setStepValues,
    movementValues,
    currentTooth,
    handleValueChange,
    selectedPointRotation,
    selectedPointTip,
    selectedPointTorque,
    viewModeSingle,
}) => {
    const isEditingSteps = isStepEditMode;
    const isAngularMovement = ["torque", "tip", "rotation"].includes(movement);
    const unit = isAngularMovement ? "deg" : "mm";
    const displayedValue = isEditingSteps ? stepValues[movement].toFixed(2) : movementValues[movement];

    const handleIncrement = () => {
        if (isEditingSteps) {
            setStepValues((prev) => ({
                ...prev,
                [movement]: prev[movement] + 0.1,
            }));
        } else {
            applyTranslationOrRotation(currentTooth, movement, stepValues[movement]);
        }
    };

    const handleDecrement = () => {
        if (isEditingSteps) {
            setStepValues((prev) => ({
                ...prev,
                [movement]: Math.max(0.01, prev[movement] - 0.1),
            }));
        } else {
            applyTranslationOrRotation(currentTooth, movement, -stepValues[movement]);
        }
    };

    const onValueChangeInternal = (val) => {
        if (isEditingSteps) {
            setStepValues((prev) => ({
                ...prev,
                [movement]: Math.max(0.01, val),
            }));
        } else {
            handleValueChange(movement, val);
        }
    };

    const onManualChangeInternal = (val) => {
        if (!isEditingSteps) {
            const delta = val - movementValues[movement];
            applyTranslationOrRotation(currentTooth, movement, delta);
        }
    };

    return (
        <SkullItem
            type={movement}
            value={displayedValue}
            unit={unit}
            onIncrement={handleIncrement}
            onDecrement={handleDecrement}
            onValueChange={onValueChangeInternal}
            onManualChange={onManualChangeInternal}
            isStepEditMode={isStepEditMode}
            viewModeSingle={viewModeSingle}
            selectedPointRotation={selectedPointRotation}
            selectedPointTip={selectedPointTip}
            selectedPointTorque={selectedPointTorque}
        />
    );
};
